import { EnumSchema } from '../metadata-schema';

export const IndicatorCode: EnumSchema = {
	"type": "string",
	"title": "IndicatorCode",
	"enum": [
		"bbs",
		"cv",
		"exc",
		"obs",
		"op"
	]
};
